(function (angular) {
  "use strict";

  angular
    .module("alk.translations")
    .directive("alkLanguageSelect", ["alkLocaleService", function (alkLocaleService) {
      return {
        replace: true,
        restrict: "A",
        template: "" +
          "<div class=\"language-select\" ng-if=\"visible\">" +
          "<select class=\"form-control\" ng-model=\"currentLocaleDisplayName\"" +
          "ng-options=\"localesDisplayName for localesDisplayName in localesDisplayNames\"" +
          "ng-change=\"changeLanguage(currentLocaleDisplayName)\">" +
          "</select>" +
          "</div>" +
          "",
        controller: ["$scope", function ($scope) {
          $scope.currentLocaleDisplayName = alkLocaleService.getLocaleDisplayName();
          $scope.localesDisplayNames = alkLocaleService.getLocalesDisplayNames();

          //  don't show if there's one or less languages available for select
          $scope.visible = $scope.localesDisplayNames && $scope.localesDisplayNames.length > 1;

          $scope.changeLanguage = function (locale) {
            alkLocaleService.setLocaleByDisplayName(locale);
          };
        }]
      };
    }]);

})(window.angular);



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-translations/alkLanguageSelectDirective.js